import React from "react";
import { useNavigate } from "react-router-dom";
import "./PackageSectionItem.css";
import pinIcon from "../../../imgs/icons/pin.svg";
import arrowIcon from "../../../imgs/icons/arrow-notail.svg";
import starIcon from "../../../imgs/icons/star.svg";

const PackageSectionItem = ({ title, country, overview, mainImage, rating, slug }) => {
  const navigate = useNavigate();

  const handleKnowMore = () => {
    if (slug) {
      window.scrollTo(0, 0); // Scroll to top before navigation
      navigate(`/packages/${slug}`);
    }
  };

  return (
    <div className="package-card">
      {/* Image */}
      <img src={mainImage} alt={title} className="package-image" />

      {/* Content */}
      <div className="package-content">
        <div className="package-header">
          <h3 className="package-name">{title}</h3>
          <div className="package-rating">
            {Array.from({ length: rating?.stars || 0 }, (_, i) => (
              <img key={i} src={starIcon} alt="star" className="star-icon" />
            ))}
          </div>
        </div>

        <div className="package-location">
          <img src={pinIcon} alt="pin" className="pin-icon" />
          <span>{country}</span>
        </div>

        <p className="package-description">{overview}</p>

        <button className="know-more-btn" onClick={handleKnowMore}>
          Know More
          <img src={arrowIcon} alt="arrow" className="arrow-icon" />
        </button>
      </div>
    </div>
  );
};

export default PackageSectionItem;
